import React, { useState } from 'react';
import { Layout } from 'antd';
import SideMenu from './components/SideMenu/SideMenu';
import Login from './pages/Login/Login';
import Users from './pages/Users/Users';
import UserDetail from './pages/Users/UserDetail';
import Audios from './pages/Audios/Audios';
import AudioDetail from './pages/Audios/AudioDetail';
import MusicStyles from './pages/MusicStyles/MusicStyles';
import MusicStyleDetail from './pages/MusicStyles/MusicStyleDetail';
import CreateMusicStyle from './pages/MusicStyles/CreateMusicStyle';
import Genres from './pages/Genres/Genres';
import GenreDetail from './pages/Genres/GenreDetail';
import CreateGenre from './pages/Genres/CreateGenre';
import Support from './pages/Support/Support';
import Dashboard from './pages/Dashboard/Dashboard';
import SystemPage from './pages/System/System';
import CreditProducts from './pages/CreditProducts/CreditProducts';
import CreateCreditProduct from './pages/CreditProducts/CreateCreditProduct';
import CreditProductDetail from './pages/CreditProducts/CreditProductDetail';
import Notifications from './pages/Notifications/Notifications';
import Explore from './pages/Explore/Explore';
import CreateCategory from './pages/Explore/CreateCategory';
import CategoryDetail from './pages/Explore/CategoryDetail';
import CreateExploreAudio from './pages/Explore/CreateExploreAudio';
import ExploreAudioDetail from './pages/Explore/ExploreAudioDetail';
import WebhookLogs from './pages/WebhookLogs/WebhookLogs';
import Vocals from './pages/Vocals/Vocals';
import VocalDetail from './pages/Vocals/VocalDetail';
import CreateVocal from './pages/Vocals/CreateVocal';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

const { Content } = Layout;

function App() {
  const [collapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const token = localStorage.getItem('token');

  if (!token) {
    return <Login />;
  }

  return (
    <Router>
      <Layout className="app">
        <SideMenu
          collapsed={collapsed}
          mobileOpen={mobileOpen}
          onMobileClose={() => setMobileOpen(false)}
        />
        {mobileOpen && <div className="sidebar-overlay" onClick={() => setMobileOpen(false)} />}
        <Content className={`content ${collapsed ? 'content-collapsed' : ''}`}>
          <button
            className="mobile-menu-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/users" element={<Users />} />
            <Route path="/user/:id" element={<UserDetail />} />
            <Route path="/audios" element={<Audios />} />
            <Route path="/audio/:id" element={<AudioDetail />} />
            <Route path="/music-styles" element={<MusicStyles />} />
            <Route path="/music-styles/create" element={<CreateMusicStyle />} />
            <Route path="/music-styles/:id" element={<MusicStyleDetail />} />
            <Route path="/genres" element={<Genres />} />
            <Route path="/genres/create" element={<CreateGenre />} />
            <Route path="/genres/:id" element={<GenreDetail />} />
            <Route path="/support" element={<Support />} />
            <Route path="/system" element={<SystemPage />} />
            <Route path="/credit-products" element={<CreditProducts />} />
            <Route path="/credit-products/create" element={<CreateCreditProduct />} />
            <Route path="/credit-products/:id" element={<CreditProductDetail />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/explore/categories/create" element={<CreateCategory />} />
            <Route path="/explore/categories/:id" element={<CategoryDetail />} />
            <Route path="/explore/audios/create" element={<CreateExploreAudio />} />
            <Route path="/explore/audios/:id" element={<ExploreAudioDetail />} />
            <Route path="/webhook-logs" element={<WebhookLogs />} />
            <Route path="/vocals" element={<Vocals />} />
            <Route path="/vocals/create" element={<CreateVocal />} />
            <Route path="/vocals/:id" element={<VocalDetail />} />
          </Routes>
        </Content>
      </Layout>
    </Router>
  );
}

export default App;
